<div *ngIf="alertToggle" [class]="alertType" class="alert alert-dismissible" role="alert">
	<button (click)="hideAlert()" type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
	<div class="alert-message">
		<strong>{{message}}</strong>
	</div>
</div>
